/** 服务端产物在会话文件协议中的虚拟地址；不是沙箱中的真实目录。 */
const PREFIX = '/workspace/.host-artifacts/';
const REF = /^artifact:v1:([A-Za-z0-9_-]{32})$/;

/** 将已提交产物映射为带扩展名的会话文件地址，兼容 App 的预览和分享入口。 */
export function documentArtifactPath(artifactRef: string, fileName: string): string | undefined {
  const id = REF.exec(artifactRef)?.[1];
  if (!id || !fileName || /[/\\\0]/.test(fileName) || fileName === '.' || fileName === '..') return undefined;
  return `${PREFIX}${id}/${fileName}`;
}

/** 只解析固定虚拟目录；调用方仍必须核验用户和会话归属。 */
export function parseDocumentArtifactPath(value: string): { artifactRef: string; fileName: string } | undefined {
  if (!value.startsWith(PREFIX)) return undefined;
  const match = /^([A-Za-z0-9_-]{32})\/([^/\\\0]+)$/.exec(value.slice(PREFIX.length));
  if (!match || match[2] === '.' || match[2] === '..') return undefined;
  return { artifactRef: `artifact:v1:${match[1]}`, fileName: match[2] };
}
